export default __webpack_public_path__ + "static/media/gd4.21336fad.jpg";